import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import { useAPIError } from '../../../context';
import { partnershipStatus } from '../../../utils/constants';
import {
    Introduction,
    H1Title,
    ErrorBoundary,
    NoDataFoundCard,
} from '../../../components';
import { getAllPartnerships } from '../service';
import { getFilteredPartnership } from '../shared/partnershipsTools';
import {
    PartnershipCard,
    PartnershipCardGrid,
    PartnershipCardSkeleton,
} from '../shared';

const RefusedCharityRequests = ({ t }) => {
    const { addError } = useAPIError();

    const [partnershipsData, setPartnershipsData] = useState();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        getAllPartnerships()
            .then((res) => {
                isMounted &&
                    setPartnershipsData(
                        getFilteredPartnership(
                            res.data._embedded.partnership,
                            partnershipStatus.REFUSED,
                        ),
                    );
            })
            .catch((error) => {
                addError(
                    error?.response?.data.detail,
                    error?.response?.data.status,
                );
            })
            .finally(() => {
                isMounted && setIsLoading(false);
            });

        return () => {
            isMounted = false;
        };
    }, [addError]);

    return (
        <>
            <Helmet>
                <title>
                    {t('CharityPartnerships.refusedRequests.metaTitle')} -{' '}
                    {t('main.metaTitle')}
                </title>
            </Helmet>

            <H1Title title={t('CharityPartnerships.refusedRequests.title')} />

            <Introduction>
                {t('CharityPartnerships.refusedRequests.introduction')}
            </Introduction>

            {isLoading ? (
                <PartnershipCardSkeleton blockWidth="md" />
            ) : partnershipsData && partnershipsData.length > 0 ? (
                <PartnershipCardGrid>
                    {partnershipsData.map((partnership, index) => (
                        <ErrorBoundary blockWidth="lg" key={index}>
                            <PartnershipCard
                                key={index}
                                data={partnership}
                                partnershipStatus={partnershipStatus.REFUSED}
                            />
                        </ErrorBoundary>
                    ))}
                </PartnershipCardGrid>
            ) : (
                <NoDataFoundCard
                    message={t(
                        'CharityPartnerships.refusedRequests.noDataFound',
                    )}
                />
            )}
        </>
    );
};

export default withTranslation('common')(RefusedCharityRequests);
